import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IResponse } from '@shared/models/base/http-response.model';
import { environment } from '@env/environment';
import { HomePageResponse } from '@shared/communication/homepage-response';
import { SetHomePageTileRequest } from '../models/home-page-request.model';
import { Tile } from '../models/tile.model';

@Injectable({
  providedIn: 'root',
})
export class HomeService {

  // DI Services
  private readonly http: HttpClient = inject(HttpClient);

  getHomeData(): Observable<IResponse<HomePageResponse>> {
    return this.http.get<IResponse<HomePageResponse>>(new URL('homepage/gettiles', environment.apiUrl).href)
  }

  //Set custom user tiles
  setUserTiles(setHomePageTileRequests: SetHomePageTileRequest[]): Observable<IResponse<Tile[]>> {
    return this.http.post<IResponse<Tile[]>>(
      new URL(`/Homepage/SetUserTiles`, environment.apiUrl).href,
      setHomePageTileRequests,
    );
  }
}
